import { Twitter } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-[#9333EA]/20 bg-black relative">
      <div className="absolute inset-0 bg-[url('/grid.svg')] bg-center [mask-image:linear-gradient(180deg,white,rgba(255,255,255,0))] opacity-50" />
      <div className="max-w-7xl mx-auto px-4 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-xl font-bold text-[#9333EA]">
              Cryptfluencers
            </h3>
            <p className="text-sm text-nft-muted">
              The ultimate NFT collection featuring the most notorious figures in crypto history.
            </p>
          </div>

          {/* Navigation */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/"
                  className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link to="/report" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  Rarity Report
                </Link>
              </li>
              <li>
                <Link to="/documentation" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  Documentation
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  Support
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white">Legal</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/license" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  License
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-sm text-nft-muted hover:text-[#9333EA] transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Social Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-white">Community</h4>
            <div className="flex space-x-4">
              <a
                href="https://x.com/cryptfluencers"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gradient-to-r from-nft-accent/20 to-blue-500/20 text-nft-accent hover:from-nft-accent/30 hover:to-blue-500/30 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://x.com/dracattusdev"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-gradient-to-r from-nft-accent/20 to-blue-500/20 text-nft-accent hover:from-nft-accent/30 hover:to-blue-500/30 transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-nft-muted">
              © 2024 Cryptfluencers. All rights reserved.
            </p>
            <p className="text-sm text-nft-muted">
              <a href="https://koba42.com" target="_blank" rel="noopener noreferrer" className="text-[#9333EA] hover:text-[#9333EA]/80 transition-colors">Koba42 Coded</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}